import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DlsButtonModule } from '@zelis/dls/button';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { CloseButtonModule } from '../close-button/close-button.module';
import { FixedTooltipComponent } from './fixed-tooltip.component';
import { ClickOutsideModule } from '@zelis/platform-ui-components';

@NgModule({
  declarations: [FixedTooltipComponent],
  imports: [
    CommonModule,
    DlsButtonModule,
    TranslateModule,
    FlexLayoutModule,
    CloseButtonModule,
    ClickOutsideModule,
  ],
  providers: [],
  exports: [FixedTooltipComponent],
})
export class FixedTooltipModule {}
